

import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Chip,
  Divider,Checkbox, FormControlLabel
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useNavigate } from "react-router-dom";
import CustomDialog from "../../CustomDialog";
import { apiRequest } from '../../fetchSetup';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EditIcon from "@mui/icons-material/Edit";
import addressConfig from "../../Configurations/addressConfig.json";


const CommonFieldsScreen = ({ serviceData, userData: propUserData }) => {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogType, setDialogType] = useState("info");
  const [dialogTitle, setDialogTitle] = useState("Notification");
  
  const [patientType, setPatientType] = useState("self");
  const [selectedFamilyMember, setSelectedFamilyMember] = useState("");
  
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [prescription, setPrescription] = useState([]);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [appointmentDateTime, setAppointmentDateTime] = useState("");
  const [tempDate, setTempDate] = useState("");
  const [relation, setRelation] = useState("");

  const [servicePrice, setServicePrice] = useState(0);
  const [serviceList, setServiceList] = useState([]);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [userData, setUserData] = useState(null);

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [selfDataChanged, setSelfDataChanged] = useState(false);
  const [originalSelfData, setOriginalSelfData] = useState({ age: "", gender: "" });
  const getservicesApi = process.env.REACT_APP_GET_SERVICES;
  const serviceTitle = serviceData?.serviceTitle;
  const serviceImage = serviceData?.serviceImage;
  const [acceptedTerms,setAcceptedTerms]=useState(false)
  const [communities, setCommunities] = useState([]);



  const COMMUNITY_OPTIONS = addressConfig.communities;
  const BLOCK_OPTIONS = addressConfig.blocks;
  const COMMUNITY_DETAILS = addressConfig.communityDetails;

  const [deliveryAddress, setDeliveryAddress] = useState({
  full_name: "", phone: "", community_name: "", address_line1: "",
  address_line2: "", landmark: "", city: "", state: "", pincode: "",
  address_type: "home",
});
const [hasSavedAddress, setHasSavedAddress] = useState(false);
const [isEditingAddress, setIsEditingAddress] = useState(false);
const [addressErrors, setAddressErrors] = useState({});
const [savingAddress, setSavingAddress] = useState(false);

  // Helper function to show dialog
  const showDialog = (message, type = "info", title = "Notification") => {
    setDialogMessage(message);
    setDialogType(type);
    setDialogTitle(title);
    setDialogOpen(true);
  };


    // Get minimum date (today)
    const getMinDate = () => {
      const date = new Date();
      return date.toISOString().split("T")[0];
    };
  
    // Get maximum date (11 days from today to include the 10th day after today)
    const getMaxDate = () => {
      const date = new Date();
      date.setDate(date.getDate() + 11);
      return date.toISOString().split("T")[0];
    };
  

  // Check if time is within allowed range (6 AM - 10 PM)
  const isTimeInRange = (timeString) => {
    const [hours, minutes] = timeString.split(":").map(Number);
    const timeInMinutes = hours * 60 + minutes;
    const startTime = 7 * 60; // 6 AM
    const endTime = 21 * 60; // 10 PM
    return timeInMinutes >= startTime && timeInMinutes <= endTime;
  };

  // Single useEffect to load user data and initialize form
  useEffect(() => {
    const community=sessionStorage.getItem('communities')
   const parsedCommunities = JSON.parse(community);

    setCommunities(parsedCommunities)
    const storedUser = JSON.parse(sessionStorage.getItem("user")) || {};
    setUserData(storedUser);
    
    if (storedUser.family_members && Array.isArray(storedUser.family_members)) {
      setFamilyMembers(storedUser.family_members);
    }

  // ── Address hydration ──
  if (storedUser.address && storedUser.address.community_name) {
    setDeliveryAddress({
      full_name: storedUser.address.full_name || storedUser.name || "",
      phone: (storedUser.address.phone || storedUser.phone || "").replace(/^\+91/, ''),
      community_name: storedUser.address.community_name || "",
      address_line1: storedUser.address.address_line1 || "",
      address_line2: storedUser.address.address_line2 || "",
      landmark: storedUser.address.landmark || "",
      city: storedUser.address.city || "",
      state: storedUser.address.state || "",
      pincode: storedUser.address.pincode || "",
      address_type: storedUser.address.address_type || "home",
    });
    setHasSavedAddress(true);
    if(storedUser.address.address_line1!==""){
    setIsEditingAddress(false);
    }
    else{
      setIsEditingAddress(true); 
    }
  } else {
    setDeliveryAddress(prev => ({
      ...prev,
      full_name: storedUser.name || "",
      phone: (storedUser.phone || "").replace(/^\+91/, ''),
    }));
    setHasSavedAddress(false);
    setIsEditingAddress(true); // no saved address → force the form open
  }




    // Load saved form data or initialize with user data for "self"
    const savedData = JSON.parse(sessionStorage.getItem("commonFormData"));
    if (savedData) {
      setPatientType(savedData.patientType || "self");
      setSelectedFamilyMember(savedData.selectedFamilyMember || "");
      setName(savedData.name || "");
      setDob(savedData.dob || "");
      setPhone((savedData.phone || "").replace(/^\+91/, ''));
      setGender(savedData.gender || "");
      setAppointmentDateTime(savedData.appointmentDateTime || "");
      setPrescription(savedData.prescription || []);
    } else if (storedUser && storedUser.name) {
      // If no saved data and user exists, auto-populate for "self"
      setName(storedUser.name || "");
      setPhone((storedUser.phone || "").replace(/^\+91/, ''));
      setGender(storedUser.gender || "");
    }
  }, []);

  // Update form fields when patient type or selection changes
  useEffect(() => {
    if (patientType === "self" && userData) {
      setName(userData.name || "");
      setPhone((userData.phone || "").replace(/^\+91/, ''));
      setGender(userData.gender || "");
      setDob(userData.age || "");
      setOriginalSelfData({
        age: userData.age || "",
        gender: userData.gender || ""
      });
    } else if (patientType === "family" && selectedFamilyMember) {
      const member = familyMembers.find(m => m.name === selectedFamilyMember);
      if (member) {
        setName(member.name || "");
        setGender(member.gender || "");
        setDob(member.age || "");
        setPhone((userData?.phone || "").replace(/^\+91/, ''));
        setRelation(member.relation || "");
      }
    } else if (patientType === "family" && !selectedFamilyMember) {
      setName("");
      setGender("");
      setDob("");
      setPhone((userData?.phone || "").replace(/^\+91/, ''));
    } else if (patientType === "new") {
      setName("");
      setGender("");
      setDob("");
      setPhone("");
    }
  }, [patientType, selectedFamilyMember, userData, familyMembers]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await apiRequest(getservicesApi);
        const data = await res.json();
        if (Array.isArray(data)) {
          setServiceList(data);
        } else if (data.services && Array.isArray(data.services)) {
          setServiceList(data.services);
        } else {
          setServiceList([]);
        }
      } catch (err) {
        console.error("Failed to fetch services:", err);
        setServiceList([]);
      }
    };
    if (getservicesApi) {
      fetchServices();
    }
  }, [getservicesApi]);

  useEffect(() => {
    if (serviceList.length > 0 && serviceTitle) {
      const matchedService = serviceList.find(
        (s) =>
          s.name?.toLowerCase() === serviceTitle.toLowerCase() ||
          s.serviceTitle?.toLowerCase() === serviceTitle.toLowerCase()
      );

      if (matchedService) {
        setServicePrice(matchedService.price);
      } else {
        setServicePrice(0);
      }
    }
  }, [serviceList, serviceTitle]);
  
  const updateUserProfile = async (age, gender) => {
    try {
      const token = sessionStorage.getItem("token");
      
      if (!token) {
        console.error("No authentication token found");
        return false;
      }
  
      const response = await apiRequest(process.env.REACT_APP_UPDATE_USER_PROFILE_API, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          age: parseInt(age),
          gender: gender
        })
      });
  
      const data = await response.json();
  
      if (data.success) {
        // Update session storage with new user data
        const updatedUser = data.user;
        sessionStorage.setItem("user", JSON.stringify(updatedUser));
        
        console.log("User profile updated successfully");
        return true;
      } else {
        console.error("Failed to update profile:", data.error);
        return false;
      }
    } catch (error) {
      console.error("Error updating user profile:", error);
      return false;
    }
  };
  const handleAgeChange = (value) => {
    if (value === "" || (/^\d+$/.test(value) && value.length <= 3 && parseInt(value) > 0)) {
      setDob(value);
      if (patientType === "self" && value !== originalSelfData.age) {
        setSelfDataChanged(true);
      }
      if (touched.dob) {
        const error = validateField("dob", value);
        setErrors((prev) => ({ ...prev, dob: error }));
      }
    }
  };
  
  const handleGenderChange = (value) => {
    setGender(value);
    if (patientType === "self" && value !== originalSelfData.gender) {
      setSelfDataChanged(true);
    }
    setTouched((prev) => ({ ...prev, gender: true }));
    setErrors((prev) => ({ ...prev, gender: "" }));
  };

const handleAddressChange = (field, value) => {
  if (field=="phone"){
    const changedValue=value.replace(/^\+91/, '')
    console.log(changedValue)
    setDeliveryAddress(prev => ({ ...prev, [field]: changedValue }));
  if (addressErrors[field]) setAddressErrors(prev => ({ ...prev, [field]: "" }));
  }
  else{
    const changedValu=value
    setDeliveryAddress(prev => ({ ...prev, [field]: changedValu }));
  if (addressErrors[field]) setAddressErrors(prev => ({ ...prev, [field]: "" }));
  }
  
};

const applyCommunityDetails = (community) => {
  const filteredCommunities = communities.filter(
  com => com.name === community
);
console.log(filteredCommunities)
  setDeliveryAddress(prev => ({
    ...prev,
    community_name: community,
    address_line1: "", address_line2: "", landmark: "",
    city: filteredCommunities.address.city || "",
    state: filteredCommunities.address.state || "",
    pincode: filteredCommunities.address.pincode || "",
  }));
};

const validateAddress = () => {
    console.log(deliveryAddress)

  const errs = {};
  if (!deliveryAddress.full_name.trim()) errs.full_name = "Name is required";
  if (!/^\d{10}$/.test(deliveryAddress.phone)) errs.phone = "Enter a valid 10-digit phone";
  if (!deliveryAddress.community_name) errs.community_name = "Select a community";
  if (!deliveryAddress.address_line1) errs.address_line1 = "Select a block";
  if (!/^\d{6}$/.test(deliveryAddress.pincode)) errs.pincode = "Pincode must be 6 digits";
  setAddressErrors(errs);
  return Object.keys(errs).length === 0;
};

const handleSaveAddress = async () => {
  if (!validateAddress()) {
    showDialog("Please fill all required address fields correctly", "error", "Validation Error");
    return;
  }
  setSavingAddress(true);
  try {
    const response = await apiRequest(process.env.REACT_APP_UPDATE_USER_PROFILE_API, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ address: deliveryAddress }),
    });
    const data = await response.json();
    if (data.success) {
      sessionStorage.setItem("user", JSON.stringify(data.user));
      setHasSavedAddress(true);
      setIsEditingAddress(false);
      showDialog("Address saved successfully", "success", "Saved");
    } else {
      showDialog(data.error || "Failed to save address", "error", "Error");
    }
  } catch (err) {
    console.error("Error saving address:", err);
    showDialog("Failed to save address. Please try again.", "error", "Error");
  } finally {
    setSavingAddress(false);
  }
};

  const validateName = (value) => /^[A-Za-z\s]+$/.test(value);

  const validateField = (field, value) => {
    let error = "";

    switch (field) {
      case "name":
        if (!value.trim()) {
          error = "Name is required";
        } else if (value.trim().length < 2) {
          error = "Name must be at least 2 characters";
        } else if (!validateName(value)) {
          error = "Name should contain only alphabets";
        }
        break;

      case "dob":
        if (!value) {
          error = "Age is required";
        } else if (parseInt(value) < 1 || parseInt(value) > 200) {
          error = "Age must be between 1 and 200";
        }
        break;

      case "phone":
        if (!value) {
          error = "Phone number is required";
        } else if (value.length < 10) {
          error = "Phone must be 10 digits";
        } else if (value.length === 10 && !/^[6-9]\d{9}$/.test(value)) {
          error = "Enter a valid Indian phone number";
        }
        break;

      case "gender":
        if (!value) {
          error = "Please select a gender";
        }
        break;

      case "appointmentDateTime":
        if (!value) {
          error = "Please select appointment date & time";
        }
        break;

      case "familyMember":
        if (patientType === "family" && !value) {
          error = "Please select a family member";
        }
        break;
    }

    return error;
  };
  const handleSaveFamilyMember = async () => {
    try {
      
      const token = sessionStorage.getItem("token");
      
      if (!token) {
        console.error("No authentication token found");
        return false;
      }

      const response = await apiRequest(process.env.REACT_APP_UPDATE_USER_PROFILE_API, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          family_members:[...familyMembers,{name:name,gender:gender,age:dob,relation:relation}]
        })
      });

      const data = await response.json();

      if (data.success) {
        // Update session storage with new user data
        const updatedUser = data.user;
        sessionStorage.setItem("user", JSON.stringify(updatedUser));
        setDialogMessage("Family Member added successfully");
        setDialogType("success");
        setDialogOpen(true);
        console.log(" User profile updated successfully");
        return true;
      } else {
        console.error("Failed to update profile:", data.error);
        return false;
      }
    } catch (error) {
      console.error("Error updating user profile:", error);
      return false;
    }
  };

  const handleDateConfirm = () => {
    if (!tempDate) {
      showDialog("Please select a date", "warning", "Date Required");
      return;
    }

    const selected = new Date(tempDate);
    const minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 10);
    maxDate.setHours(23, 59, 59, 999);

    if (selected < minDate) {
      showDialog("Please select today or a future date", "warning", "Invalid Date");
      return;
    }

    if (selected > maxDate) {
      showDialog("Please select a date within the next 10 days", "warning", "Invalid Date");
      return;
    }

    setSelectedDate(tempDate);
    setShowDatePicker(false);
    setShowTimePicker(true);
  };

  const [tempTime12, setTempTime12] = useState("");
  const [tempAmPm, setTempAmPm] = useState("AM");

// Convert 12-hour time to 24-hour format for storage
const formatTimeTo24Hour = (time12, ampm) => {
  const [hours, minutes] = time12.split(":");
  let hour = parseInt(hours);
  
  return `${String(hour).padStart(2, "0")}:${minutes}`;
};
  const handleTimeConfirm = () => {
    if (!tempTime12) {
      showDialog("Please select a time", "warning", "Time Required");
      return;
    }
  
    // Convert 12-hour to 24-hour format
    const time24 = formatTimeTo24Hour(tempTime12, tempAmPm);
    
    if (!isTimeInRange(time24)) {
      showDialog("Please select a time between 7:00 AM and 9:00 PM", "warning", "Invalid Time");
      return;
    }
  
    if (!selectedDate) {
      showDialog("Please select a date first", "error", "Date Missing");
      return;
    }
  
    const [hours, minutes] = time24.split(":");
    const combinedDateTime = new Date(selectedDate);
    combinedDateTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);
  
    const now = new Date();
    if (combinedDateTime <= now) {
      showDialog("Please select a future date & time", "warning", "Invalid DateTime");
      return;
    }
  
    setSelectedTime(time24);
  
    const year = combinedDateTime.getFullYear();
    const month = String(combinedDateTime.getMonth() + 1).padStart(2, "0");
    const day = String(combinedDateTime.getDate()).padStart(2, "0");
    const hour = String(combinedDateTime.getHours()).padStart(2, "0");
    const minute = String(combinedDateTime.getMinutes()).padStart(2, "0");
    const second = String(combinedDateTime.getSeconds()).padStart(2, "0");
  
    const tzOffset = -combinedDateTime.getTimezoneOffset();
    const tzHours = String(Math.floor(Math.abs(tzOffset) / 60)).padStart(2, "0");
    const tzMinutes = String(Math.abs(tzOffset) % 60).padStart(2, "0");
    const tzSign = tzOffset >= 0 ? "+" : "-";
  
    const formattedDateTime = `${year}-${month}-${day}T${hour}:${minute}:${second}${tzSign}${tzHours}:${tzMinutes}`;
  
    setAppointmentDateTime(formattedDateTime);
    setShowTimePicker(false);
    setTempTime12("");
    setTempAmPm("AM");
    setTouched((prev) => ({ ...prev, appointmentDateTime: true }));
    setErrors((prev) => ({ ...prev, appointmentDateTime: "" }));
  };


  
  const formattedDateDisplay = (() => {
    if (!appointmentDateTime) return "Select Date & Time";
    try {
      const parsed = new Date(appointmentDateTime);
      if (isNaN(parsed)) return "Select Date & Time";

      return parsed.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      return "Select Date & Time";
    }
  })();

  // const handleContinue = () => {
    const handleContinue = async () => { 
    const fieldsToValidate = {name,dob,phone,gender,appointmentDateTime,};

    if (patientType === "family") {
      fieldsToValidate.familyMember = selectedFamilyMember;
    }

    const newErrors = {};
    Object.keys(fieldsToValidate).forEach((field) => {
      const error = validateField(field, fieldsToValidate[field]);
      if (error) {
        newErrors[field] = error;
      }
    });

    setErrors(newErrors);
    setTouched({
      name: true,
      dob: true,
      phone: true,
      gender: true,
      appointmentDateTime: true,
      familyMember: true,
    });

    if (Object.keys(newErrors).length > 0) {
      showDialog("Please fill all required fields correctly", "error", "Validation Error");
      return;
    }
    
    // if (serviceData?.orderType === "diagnostic") {
    //   const selectedTests = serviceData?.diagnosticOrderData?.tests || [];
    //   if (!selectedTests.length) {
    //     showDialog("Please select at least one diagnostic test before continuing.", "warning", "Test Required");
    //     return;
    //   }
    // }

    if (serviceData?.orderType === "diagnostic") {
      const selectedTests = serviceData?.diagnosticOrderData?.tests || [];
      if (!selectedTests.length) {
        showDialog("Please select at least one diagnostic test before continuing.", "warning", "Test Required");
        return;
      }
      if (!validateAddress()) {
        showDialog("Please fill all required address fields correctly", "error", "Address Required");
        return;
      }
    }
    
    const storedUser = JSON.parse(sessionStorage.getItem("user")) || {};
    let finalServicePrice;
    if (serviceData?.orderType === "diagnostic") {
      finalServicePrice = serviceData?.diagnosticOrderData?.total_amount || serviceData?.servicePrice || 0;
    } else {
      finalServicePrice = serviceData?.servicePrice || servicePrice || 0;
    }
// After validation, before formData creation
if (patientType === "self") {
  const ageChanged = dob !== originalSelfData.age;
  const genderChanged = gender !== originalSelfData.gender;
  
  if (ageChanged || genderChanged) {
    const updateSuccess = await updateUserProfile(dob, gender);
    
    if (!updateSuccess) {
      showDialog("Failed to update profile. Please try again.", "error", "Update Failed");
      return;
    }
  }
}
    const formData = {
      patientType,
      selectedFamilyMember,
      name,
      dob,
      gender,
      phone,
      selectedDate: appointmentDateTime,
      appointmentDateTime,
      prescription,
      serviceTitle,
      serviceImage,
      servicePrice: finalServicePrice,
      orderType: serviceData?.orderType,
      diagnosticOrderData: serviceData?.diagnosticOrderData,
      promoDiscount:serviceData.diagnosticOrderData.promo_discount,
      promoCode:serviceData.diagnosticOrderData.promo_code,
      appliedPromoData:serviceData.diagnosticOrderData.appliedPromoData,
      deliveryAddress: serviceData?.orderType === "diagnostic" ? deliveryAddress : null,   // ← new
    };
    console.log("formdata:::", formData);
    sessionStorage.setItem("commonFormData", JSON.stringify(formData));

    navigate("/select-payment-method", {
      state: { ...formData, storedUser },
    });
  };

  const fieldStyle = {
    height: 48,
    '& .MuiInputBase-root': {
      borderRadius: 2,
    },
  };

  return (
    <Box>
      {/* Patient Type Selection */}
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: 800, 
            color: "#333", 
            mb: 2,
            fontSize: 14
          }}
        >
          Booking For
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Chip
            label="Self"
            onClick={() => {
              setPatientType("self");
              setSelectedFamilyMember("");
              setTouched({});
              setErrors({});
            }}
            sx={{
              px: 2,
              py: 2.5,
              height: 'auto',
              fontSize: 14,
              fontWeight: 500,
              borderRadius: 2,
              border: patientType === "self" ? '2px solid #006D77' : '1px solid #E0E0E0',
              bgcolor: patientType === "self" ? '#E0F7FA' : '#fff',
              color: patientType === "self" ? '#006D77' : '#666',
              '&:hover': {
                bgcolor: patientType === "self" ? '#E0F7FA' : '#F5F5F5',
              }
            }}
          />
          <Chip
            label="Family Member"
            disabled={familyMembers.length === 0}
            onClick={() => {
              setPatientType("family");
              setSelectedFamilyMember("");
              setTouched({});
              setErrors({});
            }}
            sx={{
              px: 2,
              py: 2.5,
              height: 'auto',
              fontSize: 14,
              fontWeight: 500,
              borderRadius: 2,
              border: patientType === "family" ? '2px solid #006D77' : '1px solid #E0E0E0',
              bgcolor: patientType === "family" ? '#E0F7FA' : '#fff',
              color: patientType === "family" ? '#006D77' : '#666',
              '&:hover': {
                bgcolor: patientType === "family" ? '#E0F7FA' : '#F5F5F5',
              }
            }}
          />
          <Chip
            label="New Member"
            onClick={() => {
              setPatientType("new");
              setSelectedFamilyMember("");
              setTouched({});
              setErrors({});
            }}
            sx={{
              px: 2,
              py: 2.5,
              height: 'auto',
              fontSize: 14,
              fontWeight: 500,
              borderRadius: 2,
              border: patientType === "new" ? '2px solid #006D77' : '1px solid #E0E0E0',
              bgcolor: patientType === "new" ? '#E0F7FA' : '#fff',
              color: patientType === "new" ? '#006D77' : '#666',
              '&:hover': {
                bgcolor: patientType === "new" ? '#E0F7FA' : '#F5F5F5',
              }
            }}
          />
        </Box>
      </Box>

      {/* Family Member Selection */}
      {patientType === "family" && (
        <Box sx={{ mb: 4 }}>
          <TextField
            select
            fullWidth
            label="Select Family Member / Add"
            value={selectedFamilyMember}
            onChange={(e) => {
              setSelectedFamilyMember(e.target.value);
              setTouched((prev) => ({ ...prev, familyMember: true }));
              setErrors((prev) => ({ ...prev, familyMember: "" }));
            }}
            error={touched.familyMember && !!errors.familyMember}
            helperText={touched.familyMember && errors.familyMember}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: '#FAFAFA',
              }
            }}
          >
            <MenuItem value="" disabled>
              Choose a family member
            </MenuItem>
            {familyMembers.map((member, index) => (
              <MenuItem key={index} value={member.name}>
                {member.name} ({member.relation})
              </MenuItem>
            ))}
            <MenuItem value="add_family"sx={{
                  fontWeight: 700,
                  color: "#006D77",
                }}
              >
              + Add Family Member
            </MenuItem>
          </TextField>
        </Box>
      )}

      <Divider sx={{ my: 3 }} />






{serviceData?.orderType === "diagnostic" && (
  <Box sx={{ mb: 4 }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 800, color: "#333", fontSize: 14, display: "flex", alignItems: "center", gap: 1 }}>
        <LocationOnIcon sx={{ fontSize: 18, color: "#006D77" }} />
        Sample Collection Address
      </Typography>
      {hasSavedAddress && !isEditingAddress && (
        <Button
          size="small"
          startIcon={<EditIcon sx={{ fontSize: 16 }} />}
          onClick={() => setIsEditingAddress(true)}
          sx={{ textTransform: "none", color: "#006D77", fontWeight: 600, fontSize: 13 }}
        >
          Edit
        </Button>
      )}
    </Box>

    {!isEditingAddress ? (
      <Box sx={{ p: 2, borderRadius: 2, bgcolor: "#F0FFFE", border: "1.5px solid #B2DFDB" }}>
        <Typography fontSize={14} fontWeight={700} color="#111827">{deliveryAddress.full_name}</Typography>
        <Typography fontSize={13} color="#006D77" fontWeight={600}>{deliveryAddress.phone}</Typography>
        <Typography fontSize={13} color="#374151" sx={{ mt: 0.5, lineHeight: 1.6 }}>
          {deliveryAddress.community_name}, Block {deliveryAddress.address_line1}
          {deliveryAddress.address_line2 && `, Flat ${deliveryAddress.address_line2}`}
          <br />
          {deliveryAddress.city}, {deliveryAddress.state} - {deliveryAddress.pincode}
        </Typography>
      </Box>
    ) : (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth label="Full Name" value={deliveryAddress.full_name}
            onChange={(e) => handleAddressChange("full_name", e.target.value)}
            error={!!addressErrors.full_name} helperText={addressErrors.full_name}
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth label="Phone" value={(deliveryAddress.phone).replace(/^\+91/, '')}
            onChange={(e) => handleAddressChange("phone", e.target.value.replace(/\D/g, "").slice(0, 10))}
            error={!!addressErrors.phone} helperText={addressErrors.phone}
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            select fullWidth label="Community/Society" value={deliveryAddress.community_name} disabled
            onChange={(e) => applyCommunityDetails(e.target.value)}
            error={!!addressErrors.community_name} helperText={addressErrors.community_name}
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          >
            <MenuItem value="">Select Community</MenuItem>
            {communities.map((community) => <MenuItem key={community.name} value={community.name}>{community.name}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select fullWidth label="Block" value={deliveryAddress.address_line1}
            onChange={(e) => handleAddressChange("address_line1", e.target.value)}
            error={!!addressErrors.address_line1} helperText={addressErrors.address_line1}
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          >
            <MenuItem value="">Select Block</MenuItem>
            {BLOCK_OPTIONS.map((b) => <MenuItem key={b} value={b}>{b}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth label="Flat Number" value={deliveryAddress.address_line2}
            onChange={(e) => handleAddressChange("address_line2", e.target.value)}
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth label="Landmark (Optional)" value={deliveryAddress.landmark}
            onChange={(e) => handleAddressChange("landmark", e.target.value)}
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField fullWidth label="City" value={deliveryAddress.city} disabled
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: "#F5F5F5" } }} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField fullWidth label="State" value={deliveryAddress.state} disabled
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: "#F5F5F5" } }} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth label="Pincode" value={deliveryAddress.pincode}
            onChange={(e) => handleAddressChange("pincode", e.target.value)}
            error={!!addressErrors.pincode} helperText={addressErrors.pincode}
            size="small" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            fullWidth variant="contained" onClick={handleSaveAddress} disabled={savingAddress}
            sx={{ bgcolor: "#006D77", textTransform: "none", fontWeight: 600, borderRadius: 2, "&:hover": { bgcolor: "#004F55" } }}
          >
            {savingAddress ? "Saving..." : "Save Address"}
          </Button>
        </Grid>
      </Grid>
    )}
  </Box>
)}











      {/* Form Fields */}
      <Grid container spacing={2} direction="column">
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Full Name"
            placeholder="Enter full name"
            value={name}
            disabled={patientType === "self" || (patientType === "family" && selectedFamilyMember !== "add_family")}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[A-Za-z\s]*$/.test(value)) {
                setName(value);
                if (touched.name) {
                  const error = validateField("name", value);
                  setErrors((prev) => ({ ...prev, name: error }));
                }
              }
            }}
            onBlur={() => {
              setTouched((prev) => ({ ...prev, name: true }));
              const error = validateField("name", name);
              setErrors((prev) => ({ ...prev, name: error }));
            }}
            error={touched.name && !!errors.name}
            helperText={touched.name && errors.name}
            sx={{...fieldStyle, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: (patientType === "self" || (patientType === "family" && selectedFamilyMember !== "")) ? '#F5F5F5' : '#FAFAFA',
              }
            }}
          />
        </Grid>



         <Grid item xs={12}>
          <TextField
            fullWidth
            label="Phone"
            placeholder="Enter phone number"
            value={phone}
            disabled={patientType === "self"}
            onChange={(e) => {
              const value = (e.target.value).replace(/^\+91/, '');
              if (/^\d{0,10}$/.test(value)) {
                setPhone(value);
                if (touched.phone) {
                  const error = validateField("phone", value);
                  setErrors((prev) => ({ ...prev, phone: error }));
                }
              }
            }}
            onBlur={() => {
              setTouched((prev) => ({ ...prev, phone: true }));
              const error = validateField("phone", phone);
              setErrors((prev) => ({ ...prev, phone: error }));
            }}
            inputProps={{ maxLength: 10 }}
            type="tel"
            error={touched.phone && !!errors.phone}
            helperText={touched.phone && errors.phone}
            sx={{...fieldStyle, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: patientType === "self" ? '#F5F5F5' : '#FAFAFA',
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Age"
            type="number"
            placeholder="Enter age"
            value={dob}
            // disabled={patientType === "family" && selectedFamilyMember !== ""}
            inputProps={{ min: 1, max: 200}}
            onChange={(e) => handleAgeChange(e.target.value)}
            // onChange={(e) => {
            //   const value = e.target.value;
            //   if (value === "" || (/^\d+$/.test(value) && value.length <= 2 && parseInt(value) > 0)) {
            //     setDob(value);
            //     if (touched.dob) {
            //       const error = validateField("dob", value);
            //       setErrors((prev) => ({ ...prev, dob: error }));
            //     }
            //   }
            // }}
            onBlur={() => {
              setTouched((prev) => ({ ...prev, dob: true }));
              const error = validateField("dob", dob);
              setErrors((prev) => ({ ...prev, dob: error }));
            }}
            error={touched.dob && !!errors.dob}
            helperText={touched.dob && errors.dob}
            sx={{...fieldStyle, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: (patientType === "family" && selectedFamilyMember !== "") ? '#F5F5F5' : '#FAFAFA',
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="Gender"
            value={gender}
            // disabled={patientType === "" || (patientType === "" && selectedFamilyMember !== "")}
            onChange={(e) => handleGenderChange(e.target.value)}
            // onChange={(e) => {
            //   setGender(e.target.value);
            //   setTouched((prev) => ({ ...prev, gender: true }));
            //   setErrors((prev) => ({ ...prev, gender: "" }));
            // }}
            error={touched.gender && !!errors.gender}
            helperText={touched.gender && errors.gender}
            sx={{
              ...fieldStyle, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: (patientType === "self" || (patientType === "family" && selectedFamilyMember !== "")) ? '#F5F5F5' : '#FAFAFA',
              }
            }}
          >
            <MenuItem value="" disabled>
              Select Gender
            </MenuItem>
            <MenuItem value="male">Male</MenuItem>
            <MenuItem value="female">Female</MenuItem>
            <MenuItem value="other">Other</MenuItem>
          </TextField>
        </Grid>
         {patientType === "family" && ( <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Relation"
            placeholder="Enter Relation"
            value={relation}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[A-Za-z\s]*$/.test(value)) {
                setRelation(value);
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: '#FAFAFA',
              }
            }}
          />
        </Grid>)}

        <Grid item xs={12}>
          <Box
            onClick={() => {
              setShowDatePicker(true);
              setTouched((prev) => ({ ...prev, appointmentDateTime: true }));
            }}
            sx={{
              p: 2,
              cursor: "pointer",
              border: touched.appointmentDateTime && errors.appointmentDateTime
                ? "1px solid #EF4444"
                : "1px solid #E0E0E0",
              borderRadius: 2,
              bgcolor: '#FAFAFA',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              transition: 'all 0.2s',
              '&:hover': {
                bgcolor: '#F5F5F5',
                borderColor: '#006D77'
              }
            }}
          >
            <CalendarTodayIcon sx={{ color: appointmentDateTime ? '#006D77' : '#999', fontSize: 20 }} />
            <Typography
              fontSize={14}
              color={appointmentDateTime ? "#006D77" : "#999"}
              fontWeight={appointmentDateTime ? 500 : 400}
            >
              {formattedDateDisplay}
            </Typography>
          </Box>
          {touched.appointmentDateTime && errors.appointmentDateTime && (
            <Typography color="error" fontSize={12} sx={{ mt: 0.5, ml: 1 }}>
              {errors.appointmentDateTime}
            </Typography>
          )}
          <Typography fontSize={12} color="text.secondary" sx={{ mt: 1, ml: 1 }}>
            Available: 10+ days from today, 7:00 AM - 9:00 PM
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Button
            component="label"
            fullWidth
            variant="outlined"
            startIcon={<AttachFileIcon />}
            sx={{...fieldStyle, 
              py: 1.5,
              borderRadius: 2,
              borderColor: '#E0E0E0',
              color: '#666',
              textTransform: 'none',
              fontSize: 14,
              fontWeight: 500,
              bgcolor: '#FAFAFA',
              '&:hover': {
                bgcolor: '#F5F5F5',
                borderColor: '#006D77'
              }
            }}
          >
            Medical Documents (Optional)
            <input
              type="file"
              hidden
              multiple
              accept="image/*,.pdf"
              onChange={(e) => setPrescription(Array.from(e.target.files))}
            />
          </Button>
        </Grid>
      </Grid>

      {prescription.length > 0 && (
        <Box sx={{ mt: 3, p: 2, bgcolor: '#F9F9F9', borderRadius: 2 }}>
          <Typography variant="body2" fontWeight={600} mb={1.5} color="#333">
            Uploaded Files ({prescription.length})
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {prescription.map((file, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1.5,
                  bgcolor: '#fff',
                  borderRadius: 1.5,
                  border: '1px solid #E0E0E0'
                }}
              >
                <Typography fontSize={13} color="#555">
                  📄 {file.name}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() =>
                    setPrescription((prev) => prev.filter((_, i) => i !== index))
                  }
                  sx={{ 
                    color: '#999',
                    '&:hover': {
                      color: '#EF4444',
                      bgcolor: '#FEE2E2'
                    }
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {patientType === "family" && (
          <Button
            fullWidth
            variant="outlined"
            sx={{
              mt: 3,
              py: 1.6,
              borderRadius: 2.5,
              borderColor: "#006D77",
              color: "#006D77",
              fontSize: 15,
              fontWeight: 600,
              textTransform: "none",
              "&:hover": {
                borderColor: "#004F55",
                bgcolor: "#E0F7FA",
              },
            }}
            onClick={handleSaveFamilyMember}
          >
            Save Family Member
          </Button>
        )}

        <FormControlLabel style={{paddingTop:10,display: "flex", justifyContent: "center", alignItems: "center",}}
                    
          control={
            <Checkbox
              size="small"
              checked={acceptedTerms || false}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
          }
          label={
            <Typography variant="body2">
              Accept Ayuja's{" "}
              <a href="/terms&conditions" target="_blank" rel="noopener noreferrer"
                style={{ color: "#007a85", fontWeight: "bold", textDecoration: "none" }}>
                Terms and Conditions
              </a>
                <span style={{ color: "red", marginLeft: 2 ,fontSize:19}}>*</span>
            </Typography>
          }
        />

      <Button
        fullWidth
        variant="contained"
        sx={{
          mt: 2,
          py: 1.8,
          borderRadius: 2.5,
          bgcolor: acceptedTerms ? "#006D77":"#C4C4C4",
          fontSize: 15,
          fontWeight: 600,
          textTransform: 'none',
          boxShadow: '0 4px 12px rgba(0, 109, 119, 0.3)',
          "&:hover": { 
            bgcolor:acceptedTerms ? "#004F55":"#C4C4C4",
            boxShadow: acceptedTerms ? '0 6px 16px rgba(0, 109, 119, 0.4)':"#C4C4C4",
          },
        }}
        onClick={handleContinue}
        disabled={!acceptedTerms}
      >
        Book Appointment
      </Button>

      {/* Date Picker Dialog */}
      <Dialog 
        open={showDatePicker} 
        onClose={() => setShowDatePicker(false)} 
        maxWidth="xs" 
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Select Date</DialogTitle>
        <DialogContent>
          <Typography fontSize={12} color="text.secondary" mb={2}>
            Appointments available 
          </Typography>
          <TextField
            type="date"
            fullWidth
            value={tempDate}
            onChange={(e) => setTempDate(e.target.value)}
            inputProps={{
              min: getMinDate(),
              max: getMaxDate(),
            }}
            sx={{ 
              mt: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            onClick={() => setShowDatePicker(false)}
            sx={{ 
              textTransform: 'none',
              color: '#666'
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleDateConfirm} 
            variant="contained" 
            sx={{ 
              bgcolor: "#006D77",
              textTransform: 'none',
              px: 3,
              '&:hover': { bgcolor: '#004F55' }
            }}
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>

      {/* Time Picker Dialog */}
      {/* <Dialog 
        open={showTimePicker} 
        onClose={() => setShowTimePicker(false)} 
        maxWidth="xs" 
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Select Time</DialogTitle>
        <DialogContent>
          <Typography fontSize={12} color="text.secondary" mb={2}>
            Service available: 6:00 AM - 10:00 PM
          </Typography>
          <TextField
            type="time"
            fullWidth
            value={tempTime}
            onChange={(e) => setTempTime(e.target.value)}
            inputProps={{
              min: "06:00",
              max: "22:00"
            }}
            sx={{ 
              mt: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            onClick={() => setShowTimePicker(false)}
            sx={{ 
              textTransform: 'none',
              color: '#666'
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleTimeConfirm} 
            variant="contained" 
            sx={{ 
              bgcolor: "#006D77",
              textTransform: 'none',
              px: 3,
              '&:hover': { bgcolor: '#004F55' }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog> */}


      {/* Time Picker Dialog */}
<Dialog 
  open={showTimePicker} 
  onClose={() => {
    setShowTimePicker(false);
    setTempTime12("");
    setTempAmPm("AM");
  }} 
  maxWidth="xs" 
  fullWidth
  PaperProps={{
    sx: { borderRadius: 3 }
  }}
>
  <DialogTitle sx={{ fontWeight: 600 }}>Select Time</DialogTitle>
  <DialogContent>
    <Typography fontSize={12} color="text.secondary" mb={2}>
      Service available: 6:00 AM - 10:00 PM
    </Typography>
    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
      <TextField
        type="time"
        fullWidth
        label="Time"
        value={tempTime12}
        onChange={(e) => setTempTime12(e.target.value)}
        inputProps={{
          step: 300 // 5 min intervals
        }}
        sx={{ 
          flex: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          }
        }}
      />
     
    </Box>
  </DialogContent>
  <DialogActions sx={{ p: 2, gap: 1 }}>
    <Button 
      onClick={() => {
        setShowTimePicker(false);
        setTempTime12("");
        setTempAmPm("AM");
      }}
      sx={{ 
        textTransform: 'none',
        color: '#666'
      }}
    >
      Cancel
    </Button>
    <Button 
      onClick={handleTimeConfirm} 
      variant="contained" 
      sx={{ 
        bgcolor: "#006D77",
        textTransform: 'none',
        px: 3,
        '&:hover': { bgcolor: '#004F55' }
      }}
    >
      Confirm
    </Button>
  </DialogActions>
</Dialog>

      {/* Custom Dialog */}
      <CustomDialog
        open={dialogOpen}
        message={dialogMessage}
        title={dialogTitle}
        type={dialogType}
        onClose={() => setDialogOpen(false)}
      />
    </Box>
  );
};

export default CommonFieldsScreen;